// extracted by mini-css-extract-plugin
export default {"mCard":"Pq-z","image":"Qq-z","imageNoBackground":"Rq-z","fullWidth":"Sq-z"};